import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../../functions/api";
import {
  TextField,
  Typography,
  Button,
  Box,
  Checkbox,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Autocomplete,
  Divider,
  IconButton,
  LinearProgress,
} from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import ResponsiveDialog from "../../shared/components/ResponsiveDialog";
import { useSessionStorage } from "../../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../../constants/localStorage";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import { CheckCircleOutline } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
function LoadingCircle(props) {
  const { t } = useTranslation();
  //Standardfelder
  const theme = useTheme();

  return (

    <Box sx={{height:75}}> <Box sx={{ display: 'flex', alignItems: 'center'}}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" color={props.isLoading  ?"secondary":props.success?"primary":"error"} {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
      <Box alignContent={"center"} justifyContent={"center"} sx={{ position: "relative", display: "inline-flex", alignContent: "center", width: "100%" }}>          
      <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {props.isLoading ? (
            <Typography variant="caption" component="div" color="text.secondary">{`${Math.round(props.value)}%`}</Typography>
          ) : props.success ? (
            <IconButton onClick={props.onClick}>
              <CheckCircleOutline />
            </IconButton>
          ) : (
            <>
              <IconButton disabled>
                <CloseIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
      {props.isLoading ? (
        <Typography align="center">Beleg wird versucht auszulesen</Typography>
      ) : props.success ? (
        <Typography align="center">Beleg ausgelesen. Klicken um die Werte zu übernehmen</Typography>
      ) : (
        <Typography align="center">Beleg konnten nicht ausgelesen werden.Daten bitte manuell eingeben!</Typography>
      )}
    </Box>
  );
}

export default LoadingCircle;
